import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { includes, noop } from 'lodash';
import classnames from 'classnames';
import React from 'react';
import styles from './popover.scss';
import { KEY_CODES } from '../../widget';
import { ScrollbarWrapper } from '../scrollbar-wrapper/scrollbar-wrapper';
export class Popover extends React.Component {
  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick, false);
    document.addEventListener('keydown', this.handleDocumentKeyPress, false);
    window.addEventListener('blur', this.handleWindowBlur, false);
  }
  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick, false);
    document.removeEventListener('keydown', this.handleDocumentKeyPress, false);
    window.removeEventListener('blur', this.handleWindowBlur, false);
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "containerRef", void 0);
    _defineProperty(this, "openerRef", void 0);
    _defineProperty(this, "contentRef", void 0);
    _defineProperty(this, "closingPromise", Promise.resolve());
    _defineProperty(this, "handleWindowBlur", () => {
      if (this.props.isOpen) {
        return;
      }
      this.setIsOpen(false);
    });
    _defineProperty(this, "handleDocumentClick", event => {
      if (!this.containerRef) {
        return;
      }
      if (!this.containerRef.contains(event.target)) {
        if (this.state.isOpen) {
          this.setIsOpen(false);
        }
      }
    });
    _defineProperty(this, "handleDocumentKeyPress", event => {
      if (!this.containerRef) {
        return;
      }
      if (event.keyCode === KEY_CODES.ESC) {
        if (this.containerRef.contains(event.target)) {
          this.setOpenFromKeyboard(false);
          return;
        }
        this.setIsOpen(false);
      }
    });
    _defineProperty(this, "handleKeyDown", event => {
      if (includes([KEY_CODES.DOWN, KEY_CODES.UP, KEY_CODES.SPACE, KEY_CODES.ENTER], event.keyCode)) {
        event.preventDefault();
        if (!this.state.isOpen) {
          this.setOpenFromKeyboard(true);
        }
      }
    });
    _defineProperty(this, "setOpenFromKeyboard", isOpen => {
      this.setIsOpen(isOpen, () => {
        if (isOpen) {
          if (this.contentRef && this.props.focusContentOnOpen) {
            this.contentRef.childNodes[0].focus();
          }
        } else {
          if (this.openerRef) {
            this.openerRef.focus();
          }
        }
      });
    });
    _defineProperty(this, "toggleOpen", event => {
      if (event.type === 'mousedown' && event.button === 0) {
        event.preventDefault();
        this.setIsOpen(!this.state.isOpen);
      }
    });
    _defineProperty(this, "saveRef", refName => ref => this[refName] = ref);
    _defineProperty(this, "handleContentKeydown", event => {
      if (includes([KEY_CODES.SPACE, KEY_CODES.ENTER], event.keyCode)) {
        event.preventDefault();
        this.setOpenFromKeyboard(false);
      }
    });
    this.state = {
      isOpen: props.isOpen,
      isClosing: false
    };
  }
  UNSAFE_componentWillReceiveProps(_ref) {
    let {
      isOpen
    } = _ref;
    if (isOpen !== this.props.isOpen) {
      this.setIsOpen(isOpen);
    }
  }
  setIsOpen(isOpen, onStateChanged) {
    if (onStateChanged === void 0) {
      onStateChanged = noop;
    }
    this.closingPromise.then(() => {
      this.setState({
        isClosing: !isOpen
      });
      if (isOpen) {
        this._setIsOpen(isOpen, onStateChanged);
        return;
      }
      this.closingPromise = new Promise(resolve => setTimeout(resolve, 300)).then(() => {
        this._setIsOpen(isOpen, onStateChanged);
      });
    });
  }
  _setIsOpen(isOpen, onStateChanged) {
    this.setState({
      isOpen,
      isClosing: false
    }, onStateChanged);
    this.props.onToggle(isOpen);
  }
  render() {
    const {
      className,
      content,
      children,
      dataHook,
      isFocusable,
      ariaRole,
      ariaLabel,
      openerClassName,
      dropdownPosition
    } = this.props;
    const {
      isOpen,
      isClosing
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      ref: this.saveRef('containerRef'),
      "data-hook": "popover-container",
      className: styles.container
    }, /*#__PURE__*/React.createElement("div", {
      role: ariaRole,
      className: openerClassName,
      "aria-label": ariaLabel,
      "aria-haspopup": "true",
      "aria-expanded": isOpen,
      ref: this.saveRef('openerRef'),
      onKeyDown: this.handleKeyDown,
      onMouseDown: this.toggleOpen,
      tabIndex: isFocusable ? 0 : -1,
      "data-hook": dataHook
    }, children), React.Children.count(content) > 0 && /*#__PURE__*/React.createElement(ScrollbarWrapper, {
      dataHook: "popover-content",
      className: classnames(styles.content, className, {
        [styles.open]: isOpen,
        [styles.closing]: isClosing,
        [styles.left]: dropdownPosition === 'left',
        [styles.right]: dropdownPosition === 'right'
      })
    }, /*#__PURE__*/React.createElement("div", {
      ref: this.saveRef('contentRef'),
      "aria-hidden": !isOpen,
      onMouseDown: this.toggleOpen,
      onKeyDown: this.handleContentKeydown
    }, isOpen && content)));
  }
}
_defineProperty(Popover, "defaultProps", {
  isFocusable: true,
  onToggle: noop,
  ariaRole: 'button',
  dataHook: 'open-popover',
  focusContentOnOpen: true,
  isOpen: false
});
//# sourceMappingURL=popover.js.map